export const reloadPage = (): void => {
  window.location.reload();
};
